import {ExpandableSelectableListMultiple} from './expandable-selectable-list-multiple';
import {SelectableListMultiple} from './selectable-list-multiple';

export const List = {
	ExpandableSelectableListMultiple,
	SelectableListMultiple,
};
